export default "__VITE_ASSET__C2hX_iOT__"